// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 3.5H10.5M2.5 8H10.5M2.5 12.5H6',
  'M13.5 3.5V10.5C13.5 11.6 12.6 12.5 11.5 12.5H9M11 10.5L9 12.5L11 14.5',
];
